import React from 'react'
import { BASE_URL, RULES_FOR_BUYERS_ROUTE, RULES_FOR_SELLERS_ROUTE, SUPPORT_EMAIL } from '../../utils/consts'

const RulesForBuyers = () => {
	return (
		<div className='container'>
			<h1 className='text-xl md:text-2xl'>Правила для покупателей</h1>

			<p className='mt-10'>
				Общество с ограниченной ответственностью «ГИР СТОР» (ООО «ГИР СТОР», ИНН 3300013334)
				является владельцем и правообладателем сайта{' '}
				<a className='link' href={BASE_URL}>
					{BASE_URL}
				</a>{' '}
				(далее – Платформа) и предоставляет возможность совершать покупки запасных частей к
				автомобилям (далее – запчасти, товар) по объявлениям, размещенным на Платформе
				другими пользователями. Настоящие Правила в силу статьи 428 ГК РФ являются условиями
				договора присоединения по оказанию услуг на Платформе. При этом, Правила не являются
				публичным договором. В случае нарушения установленных правил или лицензионного
				соглашения, размещенного на сайте, администрация Платформы заблокировать личный
				кабинет пользователя. При этом пользователи самостоятельно несут ответственность за
				допущенные ими нарушения законодательства и прав третьих лиц. Администрация
				Платформы оставляет за собой право заключать, не заключать или расторгнуть в любое
				время настоящий договор с любым пользователем без объяснения причин. Настоящие
				Правила могут быть изменены и/или дополнены администрацией Платформы в одностороннем
				порядке без какого-либо специального уведомления. Настоящие Правила являются
				открытым и общедоступным документом. Действующая редакция Правил располагается в
				сети Интернет по адресу:&nbsp;
				{BASE_URL}
				{RULES_FOR_BUYERS_ROUTE}. Пользователям рекомендуется регулярно проверять условия
				настоящих Правил на предмет их изменения и/или дополнения. Продолжение использования
				сайта пользователем после внесения изменений и/или дополнений в настоящие Правила
				означает принятие и согласие Пользователя с такими изменениями и/или дополнениями.
			</p>

			<h2 className='mt-5 text-xl font-bold'>1. Термины и определения</h2>
			<ul className='mt-3'>
				<li>
					1.1. Сайт, Платформа — объект интеллектуальной собственности, представляющий собой
					совокупность программ ЭВМ, веб-страниц, баз данных, фото и видео, графических и
					текстовых элементов, находящийся на сервере правообладателя и доступный для
					использования по адресу{' '}
					<a className='link' href={BASE_URL}>
						{BASE_URL}
					</a>
				</li>
				<li>
					1.2. Продавец – любое физическое дееспособное лицо, достигшее возраста 18 лет,
					юридическое лицо или индивидуальный предприниматель, являющийся пользователем
					Платформы и предлагающий к продаже путем размещения объявления на Платформе
					Товар.
				</li>
				<li>
					1.3. Покупатель – любое физическое дееспособное лицо, достигшее возраста 18 лет,
					юридическое лицо или индивидуальный предприниматель, являющийся пользователем
					Платформы и желающее приобрести или приобретающее Товар, объявление о котором
					размещено на Платформе.
				</li>
				<li>
					1.4. Объявление — размещенные на Платформе данные о Товаре, его технических и иных
					характеристиках, а также о Продавце.
				</li>
				<li>
					1.5. Товар – предлагаемые к продаже путем размещения объявления на Платформе
					запасные части/комплектующие к автомобилям.
				</li>
			</ul>

			<h2 className='mt-5 text-xl font-bold'>2. Общие положения</h2>
			{/* <p className='mt-3'>
				2.1. Оставляя запрос на покупку товара, Покупатель подтверждает, что ознакомлен и
				согласен с настоящими Правилами.
			</p> */}
			<ul className='mt-3'>
				<li>
					2.1. Оставляя запрос на покупку товара, Покупатель подтверждает, что ознакомлен и
					согласен с настоящими Правилами.
				</li>
				<li>
					2.2. Передача товара и расчеты за товары производятся непосредственно между
					Продавцом и Покупателем без участия Платформы и без использования для этих целей
					ее сервисов.
				</li>
				<li>
					2.3. Организация доставки товара Покупателю осуществляется непосредственно
					Продавцом без участия Платформы.
				</li>
				<li>
					2.4. На Платформе может содержаться информация о компаниях, оказывающих услуги по
					доставке товара, которой Продавец или Покупатель вправе воспользоваться.
				</li>
				<li>
					2.5. Вся информация о товаре и о продавце товара в объявлениях представлена
					Продавцами, разместившими данные объявления.
				</li>
				<li>
					2.6. Все общение по поводу совершения, изменения, прекращения сделок купли-продажи
					товара осуществляется непосредственно между Продавцом и Покупателем посредством
					мессенджера Платформы или иными возможными способами. Платформа не пересылает
					Продавцу сообщения Покупателя (в том числе уведомления об отказе от исполнения
					договора).
				</li>
				<li>
					2.7. К отношениям, не урегулированным положениями настоящих правил, в том числе к
					порядку заключения договора купли-продажи между Продавцом и Покупателем, порядку
					подтверждения Заявки и порядку формирования Заказа Продавцом, обязанностям и
					ответственности Продавца применяются Правила размещения объявлений,
					опубликованные по адресу{' '}
					<a className='link' href={RULES_FOR_BUYERS_ROUTE}>
						{BASE_URL + RULES_FOR_BUYERS_ROUTE}
					</a>
					.
				</li>
			</ul>

			<h2 className='mt-5 text-xl font-bold'>3. Использование Платформы Покупателем</h2>
			<ul className='mt-3'>
				<li>
					3.1. Для осуществления первой покупки Покупателю необходимо зарегистрироваться,
					а для последующих покупок – авторизоваться на Платформе.
				</li>
				<li>
					3.2. При регистрации Покупателю необходимо заполнить всю предлагаемую
					соответствующей формой информацию.
				</li>
				<li>3.3. Информация о Покупателе должна соответствовать действительности.</li>
				<li>
					3.4. Зарегистрировавшись на сайте, Покупатель автоматически соглашается на
					обработку своих персональных данных. Платформа обязуется не предоставлять
					персональные данные третьим лицам кроме случаев, предусмотренных действующим
					законодательством.
				</li>
				<li>
					3.5. Покупатель самостоятельно предоставляет/размещает на Платформе информацию о
					себе для общего доступа всем пользователям (делает ее общедоступной).
				</li>
				<li>
					3.6. Логин не должен содержать контактные данные (номер телефона, email, адрес
					сайта и т.д.), оскорбления, нецензурную лексику и названия, использование
					которых в Российской Федерации запрещено.
				</li>
				<li>
					3.7. Зарегистрировавшись на сайте, Покупатель автоматически соглашается на
					отправку электронных сообщений о событиях в его кабинете на подтвержденные
					номера телефонов и адреса электронной почты.
				</li>
				<li>
					3.8. Покупатель несет ответственность за сохранность своих учетных данных,
					логина и пароля и обязуется не передавать их третьим лицам.
				</li>
				<li>
					3.9. Все действия на Платформе, выполненные после ввода логина и пароля,
					считаются действиями Покупателя.
				</li>
				<li>
					3.10. До осуществления покупки Покупатель должен ознакомиться с описанием
					товара, фотографиями и его ценой. При выборе товара и Продавца Покупатель должен
					проявлять осмотрительность. При необходимости Покупатель вправе задать вопросы и
					уточнить информацию у Продавца.
				</li>
				<li>
					3.11. Для уточнения статуса сделки, внесения изменений или отмены покупки
					Покупателю необходимо связаться непосредственно с Продавцом. Функционал
					Платформы не предоставляет возможности отслеживания заказов, внесения изменений
					или отмены заказов.
				</li>
				<li>
					3.12. Все совершаемые благодаря размещению объявления на Платформе сделки и
					платежи между Продавцами и Покупателями заключаются и исполняются без прямого
					или косвенного участия владельца Платформы. Любые вопросы, связанные с покупкой
					товара, его качеством, обменом, возвратом и в любых иных случаях,
					предусмотренных действующим законодательством о защите прав потребителей,
					подлежат урегулированию непосредственно между Продавцом и Покупателем.{' '}
				</li>
				<li>
					3.13. Платформа не является организатором заключения договора купли-продажи
					между Продавцом и Покупателем, посредником, агентом или представителем
					какого-либо Продавца или Покупателя, и/или иным заинтересованным лицом в
					отношении предлагаемой/заключаемой/исполняемой между пользователями сделки или
					производимых расчетов.
				</li>
			</ul>

			<h2 className='mt-5 text-xl font-bold'>4. Заверения и гарантии Покупателя</h2>
			<ul className='mt-3'>
				<li>
					4.1 Покупатель настоящим предоставляет согласие на передачу с использованием
					Платформы сведений, которые вносятся Покупателем, в том числе персональных
					данных, Продавцу для целей исполнения Продавцом договора купли-продажи товара.
				</li>
				<li>
					4.2 Настоящим Покупатель гарантирует, что все передаваемые сведения получены им
					на законных основаниях, соответствуют действительности, не нарушают прав третьих
					лиц.
				</li>
				<li>
					4.3 Покупатель заверяет, что предоставил при регистрации на Платформе корректные
					и актуальные данные.
				</li>
				<li>
					4.4 Все действия, осуществленные авторизованным на Платформе Покупателем,
					считаются осуществленными непосредственно Покупателем.
				</li>
				<li>
					4.5 Покупатель обязуется соблюдать положения настоящих Правил, а также иных
					положений и требований Платформы.
				</li>
				<li>
					4.6. Запрещаются нетематические сообщения и оскорбления в переписке. Вопросы и
					ответы должны касаться только дополнительного описания товара, его состояния,
					условий покупки или доставки.
				</li>
				<li>
					4.7. Запрещается рассылка коммерческих или иных видов сообщений (информации)
					лицам, не выражавшим желания их получать. Тематика сообщений должна
					соответствовать теме объявления.
				</li>
			</ul>

			<h2 className='mt-5 text-xl font-bold'>5. Ответственность и ограничения</h2>
			<ul className='mt-3'>
				<li>
					5.1 Платформа, ее владелец не несут ответственности за полноту и достоверность
					информации о продавце и товаре. Данная информация заполняется Продавцами
					самостоятельно и под свою ответственность.
				</li>
				<li>
					5.2 Платформа, ее владелец не несут ответственности за качество, сроки
					исполнения Продавцом договора купли-продажи товара, расчеты за товары и любое
					иное надлежащее исполнение Продавцом своих обязательств перед Покупателем,
					связанных с продажей товаров.
				</li>
				<li>
					5.3 Покупатель несет ответственность за сохранность своих регистрационных данных
					(логин и пароль) и любые действия на Платформе с использованием таких данных.
				</li>
				<li>
					5.4 Вся информация, размещенная на Платформе, включая базу данных, тексты, фото-
					и видеоизображения, дизайн, подбор, группировку и расположение материалов,
					является интеллектуальной собственностью ООО «ГИР СТОР» и продавцов и защищается
					нормами гражданского, административного и уголовного законодательства Российской
					Федерации, а также нормами международного права по охране интеллектуальной
					собственности.
				</li>
				<li>
					5.5 Воспроизведение и любое использование информации с Платформы разрешено
					только с письменного разрешения владельца Платформы. Копирование информации,
					содержащейся на данном сайте, может осуществляться только физическими лицами для
					личного пользования.
				</li>
				<li>
					5.6. Запрещается использование автоматизированного извлечения информации с
					Платформы без письменного разрешения ее владельца.
				</li>
				<li>
					5.7. Ни при каких обстоятельствах владелец Платформы не несет ответственности за
					любую потерю, расходы, убытки или ущерб, (потеря деловых доходов, потеря прибыли
					или любой прямой, косвенный, последующий, специальный или подобный ущерб
					вообще), являющийся результатом: любой погрешности, содержащейся в информации,
					её неполноты, задержки, прерывания в получении, ошибки или упущений в поставке;
					любого сбоя информационной системы.
				</li>
				<li>
					5.8. При использовании Платформы Покупателем, в том числе при общении в чатах не
					допускается размещение или передача любой информации, которая нарушает или может
					нарушать авторские и смежные права третьих лиц, носить угрожающий характер, быть
					ложной, обманчивой, подстрекательской, клеветнической, нарушающей
					конфиденциальность, нецензурной, порнографической, оскорбительной,
					дискриминационной, противозаконной или любой другой информации, которая может
					составлять или приводить к действиям, которые могут рассматриваться как уголовно
					наказуемые, нарушающие права любой стороны или которые могут иным способом
					служить источником уголовно-правовой ответственности или нарушать какой-либо
					другой закон. За нарушение настоящего правила наступает ответственность,
					предусмотренная нормами гражданского, административного и уголовного
					законодательства Российской Федерации, а также нормами международного права по
					охране интеллектуальной собственности. Администрация Платформы вправе в любое
					время без уведомления пользователя блокировать, удалять информацию, указанную
					выше и передавать информацию о таких фактах в правоохранительные и иные
					уполномоченные органы.
				</li>
			</ul>

			<p className='mt-3'>
				«18» апреля 2025 г. Юридический адрес и реквизиты владельца и правообладателя
				Платформы ООО «ГИР СТОР»
				<br />
				Юридический адрес: 601443, Владимирская область, Вязниковский р-н, г Вязники,
				<br />
				ул. Ленина, стр. 46
				<br />
				ИНН 3300013334
				<br />
				ОГРН 1243300005079
				<br />
				<br />
				Адрес электронной почты:{' '}
				<a className='link' href={`mailto:${SUPPORT_EMAIL}`}>
					{SUPPORT_EMAIL}
				</a>
			</p>
		</div>
	)
}

export default RulesForBuyers
